// automationEmailActionUtils.js

// ----- UTILITIES ----- //

/**
 * getNextIncludedFieldKeys
 *
 * Toggles a field key in the selected include-information list while
 * preserving only currently selectable field keys.
 *
 * @param {array} currentFieldKeys - Existing selected field keys.
 * @param {string} fieldKey - Target field key to toggle.
 * @param {Set<string>} selectableFieldKeySet - Allowed selectable keys.
 *
 * @returns {array} Next selected field keys.
 */
export const getNextIncludedFieldKeys = ({ currentFieldKeys, fieldKey, selectableFieldKeySet }) => {
  const nextSet = new Set(
    (Array.isArray(currentFieldKeys) ? currentFieldKeys : [])
      .map((value) => String(value || '').trim())
      .filter((value) => selectableFieldKeySet.has(value)),
  );

  if (nextSet.has(fieldKey)) {
    nextSet.delete(fieldKey);
  } else {
    nextSet.add(fieldKey);
  }

  return Array.from(nextSet);
};
